// ABOUTME: Detail view for a custom page, rendering its detailLayout (or the one detailLayoutFrom points to).
// ABOUTME: Passes nodeId from the URL to the layout renderer for node-editor widgets.

import { useMemo } from 'react';

import { NodeEditorSaveStateProvider } from '../context/NodeEditorSaveStateContext';
import { useCustomPages } from '../hooks/useCustomPages';
import { CustomPage } from '../types';
import { resolveDetailLayout } from '../utils/resolveDetailLayout';
import { LayoutRenderer } from './LayoutRenderer';

interface CustomPageDetailViewProps {
    page: CustomPage;
    nodeId: string;
}

export function CustomPageDetailView({ page, nodeId }: CustomPageDetailViewProps) {
    const customPages = useCustomPages();
    // The layout may come from another page, but the context stays this page's own: its
    // hierarchy, slug and filter are what the widgets act on.
    const layout = useMemo(() => resolveDetailLayout(page, customPages), [page, customPages]);

    return (
        <NodeEditorSaveStateProvider>
            <LayoutRenderer
                layout={layout}
                context={{
                    hierarchyId: page.hierarchyId,
                    nodeId,
                    objectSchemaCode: page.objectSchemaCode ?? undefined,
                    slug: page.slug,
                    filter: page.filter ?? undefined,
                }}
            />
        </NodeEditorSaveStateProvider>
    );
}
